// extracted by mini-css-extract-plugin
export var carousel = "mentors-list-module--carousel--4KNNp";
export var wrapper = "mentors-list-module--wrapper--qJIh9";